const HTML_MESSAGE_PATTERN = /<\s*(!doctype|html|head|body|table|div|p)\b/i;

export function isHtmlNotificationMessage(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  return HTML_MESSAGE_PATTERN.test(trimmed);
}

/** Extract readable text from notification HTML (email templates). */
export function stripHtmlToText(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) return '';

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(trimmed, 'text/html');
    const paragraphs = Array.from(doc.querySelectorAll('p'))
      .map((p) => p.textContent?.replace(/\s+/g, ' ').trim() ?? '')
      .filter(Boolean);
    if (paragraphs.length > 0) return paragraphs.join('\n\n');

    const text = doc.body?.textContent?.replace(/\s+/g, ' ').trim();
    if (text) return text;
  }

  return trimmed
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Case refs embedded in message text, e.g. (WP5/00001/2026). */
const INLINE_CASE_REF_PATTERN = /\(([A-Z0-9][A-Z0-9/._-]{2,})\)/i;

export function parseNotificationMessage(raw: string): { text: string; caseRef?: string } {
  const trimmed = raw.trim();
  if (!trimmed) return { text: '' };

  const text = isHtmlNotificationMessage(trimmed) ? stripHtmlToText(trimmed) : trimmed;
  const caseRefMatch = text.match(INLINE_CASE_REF_PATTERN);

  return {
    text,
    caseRef: caseRefMatch?.[1],
  };
}
